import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Score.css';

class ScoreModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      score: 0,
    };

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  showModal(score) {
    this.setState({
      hidden: false,
      score: score.toFixed(2),
    });
  }

  hideModal() {
    this.setState({
      hidden: true,
    });
  }

  render() {
    const { hidden, score } = this.state;
    const { onCancelFeedback, onSubmitFeedback, rejected } = this.props;

    return (
      <div id="confirmationModal" className={hidden ? 'hidden' : 'modal'} tabIndex="-1">
        <div className="modal-header">
          <button type="button" id="closeButton" className="close" data-dismiss="modal" aria-hidden="true" onClick={onCancelFeedback}>&times;</button>
          <h3>Submit the check</h3>
        </div>
        <div className="modal-body">
          <p>Thank you for completing the check.</p>
          <p>Here is the calculated check score.</p>
          <p className="score">
            {score}
            {' '}
            / 10.00
          </p>
          { rejected
            && (
            <p className="score-warning">
              This job has been rejected by the customer. Please remember to&nbsp;
              take the correct action based on your review.
            </p>
            )}
        </div>
        <div className="modal-footer">
          <div style={{ float: 'right' }}>
            <button id="completedConfirmBtn" type="button" className="btn btn-primary btn-small" onClick={onSubmitFeedback}>Submit feedback</button>
            <button id="cancelConfirmBtn" type="button" className="btn btn-default btn-small" onClick={onCancelFeedback}>Cancel</button>
          </div>
          <div style={{ clear: 'right' }} />
          <p className="contact">
            Please
            {' '}
            <a href="ma&#105;&#108;t&#111;&#58;%7&#52;&#114;&#37;6&#49;&#110;&#115;l&#97;to&#114;-tea%6&#68;&#64;g%65n&#103;&#111;&#46;c&#37;6Fm">contact Translator Team</a>
            {' '}
            if you have any questions or concerns.
          </p>
        </div>
      </div>
    );
  }
}

ScoreModal.propTypes = {
  rejected: PropTypes.bool,
  onSubmitFeedback: PropTypes.func.isRequired,
  onCancelFeedback: PropTypes.func.isRequired,
};

ScoreModal.defaultProps = {
  rejected: false,
};

export default ScoreModal;
